import React from 'react';
import {
  Box,
  Chip,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import { format } from 'date-fns';
import { tokens } from '../../theme';
import { ChartPanel } from './analytics/shared';

const BORDER = 'rgba(255,255,255,0.08)';

export default function FoodLogPanel({
  foodEntries = [],
  selectedDateLabel,
  onDeleteFood,
  deleting = false,
}) {
  const sorted = [...foodEntries].sort(
    (a, b) => new Date(b.timestamp || 0) - new Date(a.timestamp || 0)
  );

  return (
    <ChartPanel title="Food log" subtitle={selectedDateLabel ? `Entries for ${selectedDateLabel}` : 'Today\'s entries'}>
      <Stack spacing={0.8}>
        {sorted.length === 0 && (
          <Typography variant="body2" sx={{ color: tokens.textMuted }}>
            No food logged for this day yet.
          </Typography>
        )}
        {sorted.map((entry) => (
          <Box
            key={entry.id}
            sx={{
              p: 1.1,
              border: `1px solid ${BORDER}`,
              backgroundColor: 'rgba(255,255,255,0.02)',
            }}
          >
            <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography variant="body2" sx={{ color: tokens.cream }} noWrap>
                  {entry.foodName}
                </Typography>
                <Typography variant="caption" sx={{ color: tokens.textMuted, display: 'block' }}>
                  {(entry.quantity || 0)} {entry.unit || 'g'} · {entry.calories || 0} kcal
                  {entry.timestamp ? ` · ${format(new Date(entry.timestamp), 'h:mm a')}` : ''}
                </Typography>
                <Stack direction="row" spacing={0.5} flexWrap="wrap" useFlexGap sx={{ mt: 0.5 }}>
                  {entry.mealType && (
                    <Chip label={entry.mealType} size="small" sx={{ height: 20, fontSize: '0.65rem', borderRadius: 1 }} />
                  )}
                  {entry.mealContext && (
                    <Chip label={entry.mealContext} size="small" variant="outlined" sx={{ height: 20, fontSize: '0.65rem', borderRadius: 1 }} />
                  )}
                </Stack>
              </Box>
              <IconButton
                size="small"
                disabled={deleting}
                onClick={() => onDeleteFood?.(entry.id)}
                sx={{ color: tokens.textMuted, '&:hover': { color: tokens.danger } }}
                aria-label={`Remove ${entry.foodName}`}
              >
                <DeleteOutline fontSize="small" />
              </IconButton>
            </Stack>
          </Box>
        ))}
      </Stack>
    </ChartPanel>
  );
}
